import { TableHeadCell } from "@shared/primitive-components"

export const speedingBreakdownHeaderProps = {
  header: `Speeding breakdown`,
  tooltipContent: `The severity of the speeding during the trip. There are three categories of severity: Minor, Major and Critical speeding. Major speeding could result in a points penalty and Critical speeding a court summons. Darker colours indicate higher risk.`,
}

export const SpeedingBreakdownHeader = () => <TableHeadCell {...speedingBreakdownHeaderProps} />
